import { render, staticRenderFns } from "./AppLoading.vue?vue&type=template&id=7b8f8af0&scoped=true&"
import script from "./AppLoading.vue?vue&type=script&setup=true&lang=js&"
export * from "./AppLoading.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AppLoading.vue?vue&type=style&index=0&id=7b8f8af0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8f8af0",
  null
  
)

export default component.exports